// removed by extract-text-webpack-plugin
module.exports = {"pageNotFoundCode":"_2w4qdF6E6m87m_2wflLoB1_0","pageNotFoundDescription":"Y-EE037ORu8C4VZ3bxY___0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b09adcc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/PageNotFound.vue
// module id = Jt57
// module chunks = 6